import {DomainEvent} from './DomainEvent';
import {MatchPlaylist} from '../resources/MatchPlaylist';

export class MatchPlaylistUploaded extends DomainEvent<MatchPlaylist> {}
